<template>
  
      <center>
        <br>
 <div class="bg-white rounded-md shadow lg:w-3/4 overflow-x-auto ">

  <br>
    <h2 class="mb-8 font-bold text-3xl">Ingresos recepción {{ fechas }}</h2>
      <table class="border-r border-t w-full whitespace-nowrap">
        <tr class="border-t text-center font-bold">
          <th class="border-r px-6 pt-6 pb-4">Lote</th>
          <th class="border-r px-6 pt-6 pb-4">Fecha LLegada</th>
          <th class="border-r px-6 pt-6 pb-4">Exportador</th>
          <th class="border-r px-6 pt-6 pb-4">Hacienda</th>
          <th class="border-r px-6 pt-6 pb-4">Total Gavetas</th>
           <th class="border-r px-6 pt-6 pb-4">Total Peso Neto</th>
           <th class="border-r px-6 pt-6 pb-4">Peso Prom. Gaveta</th>
          <th class="border-r px-6 pt-6 pb-4">Descarga Inicio</th>
          <th class="border-r px-6 pt-6 pb-4">Descarga Fin</th>
          <th class="border-r px-6 pt-6 pb-4">Tiempo de Descarga</th>
          <th class="border-r px-6 pt-6 pb-4">Tiempo de Espera</th>
        </tr>
       
        <tr v-for="diario in diarios.data" :key="diario.id" class="border-t items-center hover:bg-gray-100 focus-within:bg-gray-100">
           <td class="border-r">
                {{ diario.lote }}
        
          </td>
          <td class="border-r">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('diarios.edit', diario.id)" tabindex="-1">
                {{ diario.fecha_llegada }}
            </inertia-link>
          </td>
         <td class="border-r">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('diarios.edit', diario.id)" tabindex="-1">
              <div v-if="diario.contact">
                {{ diario.contact }}
              </div>
            </inertia-link>
          </td>
           <td class="border-r">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('diarios.edit', diario.id)" tabindex="-1">
                {{ diario.origen }}     
            </inertia-link>
          </td>
          <td class="border-r">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('diarios.edit', diario.id)" tabindex="-1">
              {{ diario.total }}
            </inertia-link>
          </td>
           <td class="border-r">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('diarios.edit', diario.id)" tabindex="-1">
              {{ diario.peso }} kg
            </inertia-link>
          </td>
          <td class="border-r">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('diarios.edit', diario.id)" tabindex="-1">
              {{ diario.promedio }} kg
            </inertia-link>
          </td>
          <td class="border-r">
            <inertia-link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="route('diarios.edit', diario.id)">
              {{ diario.fecha }}
            </inertia-link>
          </td>
          <td class="border-r">
            <inertia-link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="route('diarios.edit', diario.id)">
              {{ diario.fecha_fin }}
              <icon v-if="diario.deleted_at" name="trash" class="flex-shrink-0 w-3 h-3 fill-gray-400 ml-2" />
            </inertia-link>
          </td>
          
          <td class="border-r">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('diarios.edit', diario.id)" tabindex="-1">
              {{ diario.tiempo }} h:m:s
            </inertia-link>
          </td>
          <td class="border-r">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('diarios.edit', diario.id)" tabindex="-1">
              {{ diario.espera }} h:m:s
            </inertia-link>
          </td>
          <td class="border-r w-px">
            <inertia-link class="px-4 flex items-center" :href="route('diarios.edit', diario.id)" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </inertia-link>
          </td>
        </tr>
        <tr v-if="diarios.data.length === 0">
          <td class="border-t px-6 py-4" colspan="4">No se encontraron ingresos</td>
        </tr>
        <tr class="border-t border-r text-center">
          <td style="border-color: black;" class="px-6 pb-4 border-t"><b></b></td>
          <td style="border-color: black;" class="px-6 pb-4 border-t"><b></b></td>
          <td style="border-color: black;" class="px-6 pb-4 border-t"><b></b></td>
          <td style="border-color: black;" class="px-6 pb-4 border-t"><b>Totales</b></td>
          <td style="border-color: black;" class="px-6 pb-4 border-t">{{ gavetas }}</td>
          <td style="border-color: black;" class="px-6 pb-4 border-t">{{ pesoneto }} kg</td>
          <td style="border-color: black;" class="px-6 pb-4 border-t">{{ promediogeneral }} kg</td>

          <td style="border-color: black;" class="px-6 pb-4 border-t"></td>

        </tr>     
      </table>
    </div>
    <pagination class="mt-4" :links="diarios.links" />
    <br>
 <div class="bg-white rounded-md shadow lg:w-3/4 overflow-x-auto ">
  <br>
      <h2 class="mb-8 font-bold text-3xl">Gavetas Recibidas por Exportador</h2>
<br>
    
      <table class="border-t border-r w-full whitespace-nowrap table-bordered">
        <tr class="border-t border-r text-center font-bold">
           <th class="border-t border-r px-6 pt-6 pb-4">Exportador </th>
           <th class="border-r px-6 pt-6 pb-4">Pitahaya Blanca</th>
          <th class="border-r px-6 pt-6 pb-4">Pitahaya Amarilla</th>
          <th class="border-r px-6 pt-6 pb-4">Pitahaya Roja</th>
          <th class="border-r px-6 pt-6 pb-4">Total</th>
         

        </tr>
        <tr v-for="re in res" :key="re.nombres" class="text-center border-t border-r hover:bg-gray-100 focus-within:bg-gray-100">
           <td class="border-r px-6 py-4 flex items-center">
           
                {{ re.nombres }}
          
          </td>
                <td class="border-r items-center">
                
                {{ re.blanca }}
          
          </td>
          <td class="border-r items-center">
                
                {{ re.amarilla }}
          
          </td>
          <td class="border-r items-center">
                
                {{ re.roja }}
          
          </td>
          <td class="border-r items-center">
                
                {{ re.total }}
          
          </td>
                  
          
        </tr>
        <tr class="border-t border-r text-center ">
          <td style="border-color: black;" class="border-t px-6 py-4 flex items-center">
            <b>Totales     </b> 
          </td>
          <td style="border-color: black;" class="border-t items-center">
                
            <b>   {{ blanca }}</b> 
          
          </td>
          <td style="border-color: black;" class="border-t items-center">
                
            <b>  {{ amarilla }}</b> 
          
          </td>
          <td style="border-color: black;" class="border-t items-center">
                
            <b>    {{ roja }}</b> 
          
          </td>
          <td style="border-color: black;" class="border-t items-center">
                
            <b>   {{ general }}</b> 
          
          </td>

        </tr>
      </table>
    <pagination class="mt-6" :links="res.links" />

 </div>
  <br>
</center>
</template>

<script>
import Icon from '@/Shared/Icon'
import Pagination from '@/Shared/Pagination'

export default {
  metaInfo: { title: 'Ingreso' },
  components: {
    Icon,
    Pagination,
  },
  props: {
    diarios: Object,
    gavetas: Object,
    pesoneto: Object,
    
    fechas: Object,
    tipo: Object,
    res: Array,
    amarilla: Object,
    blanca: Object,
    roja: Object,
    general: Object,
    promediogeneral: Object,


  },
}
</script>
